import React, {useCallback} from "react";

export const useSelectOnChangeValue = (fun?: (value: any) => void) => useCallback(({ target: { value }}: React.ChangeEvent<HTMLSelectElement>) => {
  if (fun) fun(value);
}, [fun]);
